/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useAsyncAction from '../../../../commonComponents/Hooks';
import FormButtons from './PublicFormButtons';
import { StyledForm } from './PublicLayout';

const PublicForm = ({
	children,
	methods,
	defaultValues,
	onSubmit: handleSubmission,
	onBackButtonClick,
	onContinueButtonClick,
	backButtonText,
	continueButtonText,
	disabled = false,
	singleColumn = false,
	validateOnChange = false,
	className = ''
}: Props) => {
	const performAsyncAction = useAsyncAction();

	const formMethods = methods ?? useForm({ defaultValues, mode: validateOnChange ? 'onChange' : 'onSubmit' });
	const { handleSubmit } = formMethods;

	const submitData = async (data: unknown) => {
		if (handleSubmission) {
			await performAsyncAction(async () => {
				await handleSubmission(data);
			});
		}
	};

	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<FormProvider {...formMethods}>
			<StyledForm onSubmit={handleSubmit(submitData)} $singleColumn={singleColumn} className={className}>
				{children}
				<FormButtons
					onBackButtonClick={onBackButtonClick}
					onContinueButtonClick={onContinueButtonClick}
					backButtonText={backButtonText}
					continueButtonText={continueButtonText}
					disabled={disabled}
				/>
			</StyledForm>
		</FormProvider>
	);
};

export default PublicForm;

interface Props {
	children: React.ReactNode;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	methods?: any;
	defaultValues?: unknown;
	onSubmit?: (data: unknown) => Promise<void> | void;
	onPartialSubmit?: () => void;
	onBackButtonClick?: () => void;
	onContinueButtonClick?: () => void;
	primaryButtonText?: string;
	secondaryButtonText?: string;
	partialSubmitButtonText?: string;
	showPrimaryButtonEndIcon?: boolean;
	singleColumn?: boolean;
	secondaryButtonVisible?: boolean;
	validateOnChange?: boolean;
	fullWidthInDesktop?: boolean | null;
	readOnly?: boolean;
	formButtonRef?: React.Ref<HTMLElement>;
	newDesign?: boolean;
	className?: string;
	isWhiteBackground?: boolean;
	smallMargin?: boolean;
	backButtonText?: string;
	continueButtonText?: string;
	disabled?: boolean;
	isSubmitButton?: boolean;
}
